import { Container, Stack, styled } from '@ethings/ui-toolkit';
import { Box } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface Props extends PropsWithChildren {
  actions: ReactNode;
  pageSubtitle: ReactNode;
  'data-testid'?: string;
}

const StyledContainer = styled(Container)({
  flexGrow: 1,
});

const LayoutMobile: FC<Props> = ({ actions, children, ...props }) => {
  return (
    <Box id="create-page" display="flex" flexDirection="column" sx={{ overflowY: 'auto', width: '100%' }}>
      <StyledContainer data-testid={props['data-testid']}>
        <Stack id="content" className="detail-content" display="flex" flexDirection="column" flexShrink={1} spacing={2} my={2}>
          {children}
        </Stack>
      </StyledContainer>
      {actions}
    </Box>
  );
};

export default LayoutMobile;
